import Lookup from 'src/componentes/select2';

const FuncaoPontoControleLookup = (props) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/FuncaoPontoControleLookup"
      clearable={false}
      {...props}
    />
  );
};

export default FuncaoPontoControleLookup;
